import HubspotContactForm from './HubspotContactForm';

export default HubspotContactForm;
